import { render, staticRenderFns } from "./canada-performance-and-portfolio-bar-chart.vue?vue&type=template&id=5a930627&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports